{
  "platform": {
    "leads": {
      "nav": "العملاء المحتملون",
      "navNew": "العملاء المحتملون، الجديدة: {{count}}",
      "title": "العملاء المحتملون",
      "subtitle": "الطلبات الواردة من نموذج طلب العرض التوضيحي في الموقع. العميل المحتمل هو بيانات تواصل لجهة مهتمة، وليس منشأة ولا مستخدماً.",
      "timeZone": "تُعرض الأوقات بمنطقتك الزمنية ({{timeZone}}).",
      "search": "ابحث بالاسم أو الشركة أو البريد الإلكتروني أو الجوال أو المرجع",
      "filters": {
        "title": "تصفية العملاء المحتملين",
        "status": "الحالة",
        "allStatuses": "كل الحالات",
        "received": "تاريخ الاستلام",
        "utcHint": "تُحتسب الأيام بالتوقيت العالمي المنسق (UTC)."
      },
      "columns": {
        "received": "وقت الاستلام",
        "name": "الاسم",
        "email": "البريد الإلكتروني للعمل",
        "mobile": "رقم الجوال",
        "puRange": "وحدات الشراء",
        "language": "اللغة",
        "page": "الصفحة",
        "status": "الحالة",
        "assignee": "مُسند إلى"
      },
      "empty": "لا توجد طلبات عرض توضيحي بعد.",
      "emptyHint": "تظهر هنا الطلبات المرسلة من نموذج طلب العرض التوضيحي في الموقع.",
      "emptyFiltered": "لا يوجد عميل محتمل يطابق هذا البحث أو عوامل التصفية هذه.",
      "unassigned": "غير مُسند",
      "companyNotProvided": "لم تُذكر (نموذج سابق)",
      "companyNotProvidedLine": "لم يُذكر اسم الشركة (نموذج سابق)",
      "status": {
        "new": "جديد",
        "contacted": "تم التواصل",
        "qualified": "مؤهل",
        "closed": "مغلق"
      },
      "puRange": {
        "1_5": "1–5",
        "6_10": "6–10",
        "11_20": "11–20",
        "21_30": "21–30",
        "30_plus": "30+",
        "not_sure": "غير متأكد"
      },
      "locale": {
        "en": "الإنجليزية",
        "ar": "العربية"
      },
      "form": {
        "book_a_demo": "احجز عرضاً توضيحياً"
      },
      "testEnvironment": "بيئة اختبار — عملاء محتملون تجريبيون فقط",
      "notProduction": "ليست بيئة الإنتاج",
      "realLeads": "بيانات استفسارات حقيقية. الوصول مقيّد. لا تستخدم هذه السجلات للاختبارات.",
      "environment": "البيئة:",
      "event": {
        "received": "استُلم الطلب",
        "statusChanged": "تغيّرت الحالة من {{from}} إلى {{to}}",
        "statusSet": "عُيّنت الحالة: {{to}}",
        "noteAdded": "أُضيفت ملاحظة داخلية",
        "assigned": "تغيّر الإسناد",
        "assignedTo": "أُسند إلى {{name}}",
        "unassigned": "أُلغي الإسناد",
        "other": "سُجّل تحديث",
        "websiteForm": "نموذج الموقع",
        "system": "النظام"
      },
      "detail": {
        "contact": "بيانات التواصل",
        "name": "الاسم",
        "company": "الشركة",
        "email": "البريد الإلكتروني للعمل",
        "mobile": "رقم الجوال",
        "mobileE164": "الصيغة الدولية",
        "notDerived": "غير مستخرجة: لم يبدأ الرقم بـ + أو 00",
        "enquiry": "تفاصيل الطلب",
        "reference": "المرجع",
        "received": "وقت الاستلام",
        "puRange": "العدد التقريبي لوحدات الشراء",
        "language": "لغة النموذج",
        "page": "صفحة المصدر",
        "form": "النموذج",
        "noticeVersion": "إصدار الإشعار",
        "notRecorded": "غير مسجّل",
        "followUp": "الحالة والإسناد",
        "status": "الحالة",
        "assignee": "مُسند إلى",
        "you": "أنت",
        "history": "السجل",
        "historyHint": "الأقدم أولاً. لا يمكن تعديل الإدخالات أو حذفها.",
        "noHistory": "لا يوجد سجل بعد."
      },
      "manage": {
        "newStatus": "الحالة الجديدة",
        "chooseStatus": "اختر حالة",
        "statusNote": "ملاحظة مع هذا التغيير",
        "statusNoteHint": "تُحفظ في السجل مع التغيير. للاستخدام الداخلي فقط.",
        "updateStatus": "تحديث الحالة",
        "statusUpdated": "تم تحديث الحالة: {{status}}.",
        "statusRequired": "اختر الحالة الجديدة.",
        "statusRefused": "لم تتغيّر الحالة",
        "notes": "ملاحظات داخلية",
        "notesHint": "يراها مشغّلو المنصة فقط، ولا تظهر للعميل المحتمل أبداً.",
        "note": "ملاحظة داخلية",
        "noteHint": "حتى 2000 حرف. تُضاف إلى السجل ولا يمكن تعديلها لاحقاً.",
        "addNote": "إضافة الملاحظة",
        "noteAdded": "أُضيفت الملاحظة.",
        "noteRequired": "اكتب الملاحظة قبل إضافتها.",
        "noteTooLong": "يجب ألا تتجاوز الملاحظة 2000 حرف.",
        "noteRefused": "لم تُضف الملاحظة",
        "assignToMe": "إسناده إليّ",
        "removeAssignment": "إلغاء الإسناد",
        "assignedToYou": "أُسند إليك.",
        "assignmentRemoved": "أُلغي الإسناد."
      },
      "email": {
        "title": "البريد إلى فريق فيدلن",
        "off": "البريد الداخلي الخاص بالعملاء المحتملين غير مُفعّل في هذه البيئة.",
        "recipient": "المرسَل إليه",
        "attempts": "عدد المحاولات",
        "queuedAt": "وقت الإدراج في قائمة الإرسال",
        "submittedAt": "وقت القبول",
        "failedAt": "وقت تعذّر الإرسال",
        "mailer": "خدمة البريد",
        "testSink": "وجهة اختبار: تُهمَل الرسالة ولا تُرسَل إلى أي صندوق بريد",
        "notProof": "وهذا ليس دليلاً على وصولها.",
        "outcomeUncertain": "النتيجة غير مؤكدة: انتهت إحدى المحاولات دون تسجيل نتيجتها.",
        "state": {
          "pending": "بانتظار الإرسال",
          "sending": "قيد الإرسال",
          "retrying": "ستُعاد المحاولة",
          "submitted": "قبلتها خدمة البريد",
          "failed": "تعذّر الإرسال"
        }
      },
      "crm": {
        "title": "المزامنة مع إدارة علاقات العملاء (Zoho)",
        "reason": "السبب",
        "attempts": "عدد المحاولات",
        "lastAttempt": "آخر محاولة",
        "syncedAt": "وقت المزامنة",
        "recordId": "رقم السجل في Zoho",
        "newTab": "(يُفتح في علامة تبويب جديدة)",
        "state": {
          "pending": "بانتظار المزامنة",
          "syncing": "قيد المزامنة",
          "synced": "تمت المزامنة",
          "retry_scheduled": "ستُعاد المحاولة",
          "failed": "تعذّرت المزامنة",
          "needs_configuration": "تحتاج إلى إعداد",
          "matching_decision": "يلزم قرار مطابقة",
          "reconciliation_required": "يلزم التحقق في Zoho قبل الإنشاء من جديد"
        },
        "error": {
          "not_configured": "المزامنة متوقفة أو غير مُعدّة",
          "environment_guard": "مُنع الإرسال: لا يُسمح لبيئة اختبار بالكتابة في بيئة الإنتاج لدى Zoho",
          "organisation_mismatch": "الربط يخص مؤسسة أو بيئة في Zoho غير التي أُعدّت",
          "data_centre_mismatch": "التفويض صادر من مركز بيانات في Zoho غير الذي أُعدّ",
          "authorisation_revoked": "أُلغي التفويض أو انتهت صلاحيته: يلزم تفويض Zoho من جديد",
          "client_rejected": "رفض Zoho مُعرّف عميل التكامل أو رمزه السري",
          "authentication_rejected": "رفض Zoho رمز الوصول حتى بعد تجديده",
          "scope_missing": "تفويض Zoho لا يشمل صلاحية تحتاجها المزامنة",
          "invalid_module": "لا يتعرّف Zoho على وحدة العملاء المحتملين أو لا يسمح بها",
          "mandatory_field_missing": "يتطلب Zoho حقلاً لا يرسله هذا التكامل",
          "invalid_field_value": "رفض Zoho اسم حقل أو قيمته",
          "record_rejected": "رفض Zoho السجل",
          "request_rejected": "رفض Zoho الطلب",
          "duplicate_record": "سجل آخر في Zoho يحمل القيمة الفريدة نفسها",
          "external_id_mismatch": "ردّ Zoho لا يطابق مُعرّف هذا العميل المحتمل",
          "rate_limited": "طلب Zoho التمهّل (تجاوز حدّ الطلبات)",
          "token_unavailable": "تعذّر إصدار رمز وصول من Zoho حالياً",
          "provider_unavailable": "ردّ Zoho بخطأ في الخادم",
          "connection_failed": "تعذّر الاتصال بـ Zoho أو انتهت مهلته",
          "unexpected_response": "تعذّرت قراءة ردّ Zoho",
          "worker_failed": "تعذّرت المحاولة داخل فيدلن",
          "outcome_unknown": "انقطع ردّ Zoho: لن يُعيد فيدلن الإرسال حتى يتحقق أحد من Zoho",
          "reference_ambiguous": "أكثر من عميل محتمل في Zoho يحمل مرجع فيدلن نفسه",
          "reference_mismatch": "العميل المحتمل في Zoho الذي يحمل هذا المرجع له بريد إلكتروني مختلف",
          "unreachable": "تعذّر الوصول إلى Zoho، ولم يُرسَل شيء",
          "company_missing": "لا توجد شركة لهذا العميل المحتمل (نموذج سابق) ويتطلبها Zoho، لذلك لم يُرسَل شيء ولا تُستخدم قيمة بديلة",
          "owner_unverified": "لم يُتحقق من أن مالك العملاء المحتملين المُعدّ في Zoho مستخدم نشط، لذلك الكتابة موقوفة"
        },
        "nextAttempt": "المحاولة التالية",
        "resolution": "المعالجة",
        "resolutionValue": {
          "reconciled": "عُثر عليه في Zoho عند تحقق لاحق",
          "linked": "رُبط بعميل محتمل موجود في Zoho بعد التحقق",
          "create_confirmed": "أُنشئ بعد التحقق في Zoho"
        }
      }
    }
  }
}
